import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-400);
  padding: var(--space-600);
  border-radius: var(--radius-brand);
  background: var(--bg-primary);
  border: 1px solid var(--border-secondary);
`

export const Title = styled.h3`
  margin: 0;
  font-size: var(--font-size-500);
  font-weight: var(--font-weight-semibold);
  color: var(--text-primary);
  line-height: var(--line-height-tight);
`

export const Description = styled.ul`
  margin: 0;
  font-size: var(--font-size-400);
  color: var(--text-secondary);
  line-height: 1.6;
  li {
    margin-bottom: var(--space-200);

    &:last-child {
      margin-bottom: 0;
    }
  }
`

export const FormSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-300);
`

export const SelectWithRefreshContainer = styled.div`
  display: flex;
  gap: var(--space-200);
  align-items: center;
`

export const ButtonContainer = styled.div`
  display: flex;
  gap: var(--space-300);
  justify-content: flex-start;
  margin-top: var(--space-200);
`
